import * as React from "react"

const Chain = props => (
  <svg
    // width={4000}
    // height={750}
    viewBox="0 0 4000 750"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{"How we Work Banner Image"}</title>
    <defs>
      <path id="a" d="M0 0h4000.74v1249.74H0z" />
      <path id="c" d="M226.041 219.667H1.054V2.055H226.04z" />
      <path
        id="e"
        d="m321.335 199.552-121.713 154.91L.452 199.552 147.986.382z"
      />
      <path
        id="g"
        d="M277.84 108.726 152.438 285.768 1.217 138.234 137.682 1.766z"
      />
      <path
        d="M1.422 221.522 34.616.225S314.93 26.042 314.93 37.109c0 11.063-88.52 188.103-88.52 188.103z"
        id="i"
      />
    </defs>
    <g
      transform="matrix(1 0 0 .87068 2.026 -178.964)"
      fill="none"
      fillRule="evenodd"
    >
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" width="100%" height="100%" />
      </mask>
      <g mask="url(#b)">
        <path
          d="M643.517 655.133c28 27.995 28 73.544.003 101.538l-54.692 54.695c-27.994 27.991-73.546 27.991-101.544 0L261.51 585.588c-27.995-27.995-27.995-73.547 0-101.544l54.691-54.692c27.995-27.994 73.547-27.994 101.539.003zM503.71 343.383c-75.398-75.398-198.082-75.398-273.481 0l-54.689 54.692c-75.402 75.399-75.402 198.083 0 273.482l225.775 225.775c75.402 75.401 198.086 75.401 273.482 0l54.691-54.689c75.4-75.396 75.4-198.083 0-273.482z"
          fill="#00b08e"
          fillRule="nonzero"
        />
        <path
          d="M1214.418 811.361c-27.995 28-73.544 28-101.539.003l-54.694-54.69c-27.991-27.995-27.991-73.548 0-101.545l225.778-225.775c27.995-27.995 73.547-27.995 101.544 0l54.692 54.694c27.994 27.992 27.994 73.544-.006 101.535zm311.747-139.803c75.401-75.402 75.401-198.086 0-273.482l-54.689-54.691c-75.399-75.4-198.083-75.4-273.482 0L972.216 569.16c-75.399 75.402-75.399 198.086 0 273.482l54.692 54.691c75.396 75.399 198.083 75.399 273.482 0zM-52.65 797.414c-39.593.003-71.802-32.206-71.8-71.797l-.002-77.345c.003-39.59 32.212-71.8 71.802-71.803h319.298c39.59.003 71.8 32.212 71.802 71.803l-.003 77.345c.003 39.59-32.206 71.8-71.8 71.797zm319.298 121.583c106.63 0 193.383-86.75 193.38-193.383v-77.342c0-106.63-86.75-193.38-193.38-193.38H-52.65c-106.633 0-193.383 86.75-193.38 193.38v77.342c-.003 106.632 86.747 193.383 193.38 193.383Z"
          fill="#b1da00"
          fillRule="nonzero"
        />
        <path
          d="M4048.143 579.003c39.594-.003 71.803 32.206 71.8 71.797l.003 77.345c-.003 39.59-32.212 71.8-71.802 71.803h-319.298c-39.59-.003-71.8-32.212-71.802-71.803l.003-77.345c-.003-39.59 32.206-71.8 71.8-71.797zm-319.297-121.58c-106.632 0-193.383 86.747-193.38 193.38v77.342c-.003 106.63 86.75 193.38 193.38 193.38h319.297c106.632 0 193.383-86.75 193.38-193.38v-77.343c.003-106.632-86.748-193.38-193.38-193.38Z"
          fill="#00b08e"
          fillRule="nonzero"
        />
        <path
          d="M3538.062 811.361c-27.995 28-73.544 28-101.539.003l-54.694-54.69c-27.992-27.995-27.992-73.548 0-101.545l225.778-225.775c27.995-27.995 73.547-27.995 101.544 0l54.691 54.694c27.995 27.992 27.995 73.544-.003 101.535zm311.746-139.803c75.402-75.402 75.402-198.086 0-273.482l-54.688-54.691c-75.399-75.4-198.083-75.4-273.482 0L3295.86 569.16c-75.399 75.402-75.399 198.086 0 273.482l54.692 54.691c75.398 75.399 198.082 75.399 273.481 0z"
          fill="#b1da00"
          fillRule="nonzero"
        />
        <path
          d="M1827.469 655.133c28 27.995 28 73.544.003 101.538l-54.692 54.695c-27.994 27.991-73.546 27.991-101.544 0l-225.775-225.778c-27.995-27.995-27.995-73.547 0-101.544l54.691-54.692c27.995-27.994 73.547-27.994 101.541.003zm-139.807-311.75c-75.399-75.398-198.083-75.398-273.479 0l-54.691 54.692c-75.402 75.399-75.402 198.083 0 273.482l225.775 225.775c75.402 75.401 198.086 75.401 273.482 0l54.691-54.689c75.4-75.396 75.4-198.083 0-273.482z"
          fill="#00b08e"
          fillRule="nonzero"
        />
        <path
          d="M2198.141 520.953c39.593-.003 71.803 32.207 71.8 71.797l.003 77.346c-.003 39.59-32.212 71.8-71.803 71.802h-319.297c-39.59-.003-71.8-32.212-71.802-71.802l.003-77.346c-.003-39.59 32.206-71.8 71.8-71.797zm-319.297-121.58c-106.63 0-193.38 86.748-193.38 193.38v77.343c0 106.629 86.75 193.38 193.38 193.38h319.297c106.632 0 193.383-86.751 193.38-193.38v-77.343c.003-106.632-86.748-193.38-193.38-193.38Z"
          fill="#007f6e"
          fillRule="nonzero"
        />
        <path
          d="M2964.394 655.133c28 27.995 28 73.544.003 101.538l-54.691 54.695c-27.995 27.991-73.547 27.991-101.544 0l-225.776-225.778c-27.994-27.995-27.994-73.547 0-101.544l54.692-54.692c27.994-27.994 73.546-27.994 101.54.003zm-139.806-311.75c-75.4-75.398-198.083-75.398-273.48 0l-54.69 54.692c-75.4 75.399-75.4 198.083 0 273.482l225.774 225.775c75.402 75.401 198.086 75.401 273.482 0l54.692-54.689c75.399-75.396 75.399-198.083 0-273.482z"
          fill="#00b08e"
          fillRule="nonzero"
        />
        <path
          d="M3502.702 706.906c0-38.193-30.962-69.157-69.157-69.157h-553.247c-38.196 0-69.157 30.964-69.157 69.157s30.961 69.158 69.157 69.158h553.247c38.195 0 69.157-30.965 69.157-69.158M1198.422 704.14c0-38.193-30.962-69.157-69.157-69.157H576.018c-38.196 0-69.157 30.964-69.157 69.157s30.961 69.155 69.157 69.155h553.247c38.195 0 69.157-30.962 69.157-69.155"
          fill="#007f6e"
        />
        <path
          d="M2808.375 632.205c0-38.193-30.962-69.157-69.157-69.157H2185.97c-38.196 0-69.157 30.964-69.157 69.157s30.961 69.155 69.157 69.155h553.247c38.195 0 69.157-30.962 69.157-69.155"
          fill="#b1da00"
        />
        <g transform="translate(3704.505 410.707)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" width="100%" height="100%" />
          </mask>
          <g mask="url(#d)">
            <path
              d="M343.638 168.296c39.593-.003 71.803 32.206 71.8 71.797l.003 77.345c-.003 39.59-32.212 71.8-71.803 71.803H24.341c-39.59-.003-71.8-32.212-71.803-71.803l.003-77.345c-.003-39.59 32.207-71.8 71.8-71.797zM24.341 46.716c-106.632 0-193.383 86.748-193.38 193.38v77.342c-.003 106.63 86.75 193.38 193.38 193.38h319.297c106.632 0 193.383-86.75 193.38-193.38v-77.342c.003-106.632-86.748-193.38-193.38-193.38Z"
              fill="#00b08e"
              fillRule="nonzero"
            />
          </g>
        </g>
        <g transform="translate(1630.426 338.613)">
          <mask id="f" fill="#fff">
            <use xlinkHref="#e" width="100%" height="100%" />
          </mask>
          <g mask="url(#f)">
            <path
              d="M197.043 316.52c28 27.995 28 73.544.003 101.538l-54.692 54.695c-27.994 27.991-73.546 27.991-101.544 0l-225.775-225.778c-27.995-27.995-27.995-73.547 0-101.544l54.691-54.692c27.995-27.994 73.547-27.994 101.541.003zM57.236 4.77c-75.399-75.399-198.083-75.399-273.479 0l-54.691 54.692c-75.402 75.399-75.402 198.083 0 273.482L-45.16 558.719c75.402 75.401 198.086 75.401 273.482 0l54.691-54.689c75.4-75.396 75.4-198.083 0-273.482z"
              fill="#00b08e"
              fillRule="nonzero"
            />
          </g>
        </g>
        <g transform="translate(1308.777 532.711)">
          <mask id="h" fill="#fff">
            <use xlinkHref="#g" width="100%" height="100%" />
          </mask>
          <g mask="url(#h)">
            <path
              d="M-94.36 278.65c-27.994 28-73.543 28-101.538.003l-54.694-54.691c-27.992-27.995-27.992-73.547 0-101.544l225.778-225.776c27.994-27.994 73.547-27.994 101.544 0l54.691 54.695c27.995 27.991 27.995 73.543-.006 101.535zm311.747-139.803c75.402-75.402 75.402-198.086 0-273.482L162.7-189.327c-75.4-75.398-198.083-75.398-273.482 0L-336.561 36.45c-75.399 75.401-75.399 198.085 0 273.481l54.691 54.692c75.397 75.399 198.083 75.399 273.482 0z"
              fill="#b1da00"
              fillRule="nonzero"
            />
          </g>
        </g>
        <g transform="translate(58.23 405.161)">
          <mask id="j" fill="#fff">
            <use xlinkHref="#i" width="100%" height="100%" />
          </mask>
          <g mask="url(#j)">
            <path
              d="M585.287 249.972c28 27.995 28 73.544.003 101.538L530.6 406.205c-27.995 27.991-73.547 27.991-101.544 0L203.279 180.427c-27.994-27.995-27.994-73.547 0-101.544l54.692-54.692c27.994-27.994 73.546-27.994 101.538.003zM445.481-61.778c-75.399-75.398-198.083-75.398-273.482 0L117.311-7.086c-75.402 75.399-75.402 198.083 0 273.482L343.086 492.17c75.401 75.401 198.085 75.401 273.481 0l54.692-54.689c75.399-75.396 75.399-198.083 0-273.482z"
              fill="#00b08e"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default Chain
